import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../../assets/css/landing.css";
import DownloadPopup from "../Components/DownloadPopup";

export default function Landing({ userAllData }) {
  const [showDownloadPopup, setShowDownloadPopup] = useState(true);

  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);

  useEffect(() => {}, []);

  return (
    <>
      {showDownloadPopup && (
        <DownloadPopup onClose={() => setShowDownloadPopup(false)} />
      )}
      <div className="leftContainer page_layout">
        <div className="Orher_page_main_section">
          <div className="main-area">
            {JSON.parse(localStorage.getItem("sitSetting"))?.site_message && (
              <div className="alrt_msg_div">
                <h5>
                  {JSON.parse(localStorage.getItem("sitSetting"))?.site_message}
                </h5>
              </div>
            )}

            {/* Live Welcome Hero Banner */}
            <div className="landing_hero_strip mb-3">
              <div className="banner-card-wrap">
                <img
                  alt="Banner"
                  className="w-100 mb-2 rounded baner_class shadow-sm banner_top"
                  src="/images/banner-top.png"
                  style={{ borderRadius: "16px" }}
                />
              </div>
            </div>

            <section className="games-section">
              <div className="games-section-headline mt-0 pb-2 mb-3">
                <div className="games-window">
                  <Link
                    className="gameCard-container"
                    to={
                      addCaseSetting?.isLudokingClassic
                        ? "/Homepage/ludoClassicManual"
                        : "#"
                    }
                  >
                    <div className="gameCard">
                      <span
                        className="badge-light-success position-absolute"
                        style={{ top: "8px", right: "8px", zIndex: 2 }}
                      >
                        {addCaseSetting?.isLudokingClassic
                          ? "◉ LIVE"
                          : "◉ Coming Soon"}
                      </span>
                      <picture className="gameCard-image">
                        <img
                          width="100%"
                          src="./images/ludoclassic.png"
                          alt="Ludo Classic"
                          className="rounded"
                        />
                      </picture>
                    </div>
                  </Link>

                 
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    
    </>
  );
}
